// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2WtLK","inputWrap":"CustomTip_inputWrap__37LfL"};